import moment from "moment";
import { GetProfileOverviewQueryQuery } from "types/graphql-schema";

import useLabel from "@apps/use-label/use-label";
import { currentOrganizationVar } from "@cache/cache";
import Button from "@components/button/button";
import AppLink from "@components/link/link";
import {
  getFormattedMeetingDateTimes,
  getUrlUsingTypename,
} from "@helpers/helpers";

import ProfileContainer from "../../profile-container";
import ProfileEmptyState from "../../profile-empty-state";

const ProfileLastOneonone = ({
  data,
}: {
  data: GetProfileOverviewQueryQuery;
}) => {
  const label = useLabel();

  const lastOneonone = data?.user?.lastOneonones?.edges[0]?.node;
  const nextOneonone = data?.user?.nextOneonones?.edges[0]?.node;
  const organization = currentOrganizationVar();

  if (!organization.featureFlags.meetings) {
    return null;
  }

  return (
    <ProfileContainer
      title={`Last ${label("1-on-1", { titleCase: true })} Summary`}
      topRightContent={
        nextOneonone &&
        nextOneonone.startDatetime &&
        nextOneonone.endDatetime ? (
          <AppLink
            to={getUrlUsingTypename(nextOneonone)}
            className="text-blue-link hover:underline"
          >
            Next {label("1-on-1")}:{" "}
            {getFormattedMeetingDateTimes(
              nextOneonone.startDatetime,
              nextOneonone.endDatetime,
            )}
          </AppLink>
        ) : null
      }
    >
      {lastOneonone ? (
        <>
          <div className="text-gray-500 font-medium">
            {moment(lastOneonone.startDatetime).format("MMM D, YYYY")}
          </div>
          {lastOneonone.transcript?.summary ? (
            <div className="text-gray-900">
              {lastOneonone.transcript.summary}
            </div>
          ) : (
            <ProfileEmptyState>No summary.</ProfileEmptyState>
          )}
          <div>
            <Button
              to={getUrlUsingTypename(lastOneonone)}
              text={`View last ${label("1-on-1")}`}
            />
          </div>
        </>
      ) : (
        <ProfileEmptyState>No last {label("1-on-1")}.</ProfileEmptyState>
      )}
    </ProfileContainer>
  );
};

export default ProfileLastOneonone;
